import React from "react";
import PropTypes from "prop-types";
import { useAdminUser } from "../../hooks/useAdminUser";
import AdminUserSelectorView from "./AdminUserSelectorView";

export default function AdminUserSelector({ onUserSelected, onSignOut }) {
    const {
        loading,
        availableUsers,
        authUser,
        setAuthUser,
        handleSelectUser,
        
        showManageAdmins,
        setShowManageAdmins,
        adminsList,
        newAdminEmail,
        setNewAdminEmail,
        handleAddAdmin,
        handleRemoveAdmin,
        saneEmail
    } = useAdminUser(onUserSelected);

    return (
        <AdminUserSelectorView
            loading={loading}
            availableUsers={availableUsers}
            authUser={authUser}
            setAuthUser={setAuthUser}
            onSelectUser={handleSelectUser}
            onSignOut={onSignOut}
            
            showManageAdmins={showManageAdmins}
            setShowManageAdmins={setShowManageAdmins}
            adminsList={adminsList}
            newAdminEmail={newAdminEmail}
            setNewAdminEmail={setNewAdminEmail}
            handleAddAdmin={handleAddAdmin}
            handleRemoveAdmin={handleRemoveAdmin}
            saneEmail={saneEmail}
        />
    );
}

AdminUserSelector.propTypes = {
    onUserSelected: PropTypes.func.isRequired,
    onSignOut: PropTypes.func,
};
